/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

export interface ICheckoutLoyaltyTextProps {
    className: string;
    text?: string;
}

/**
 * AddPaymentForm SFC.
 * @param root0
 * @param root0.className
 * @param root0.text
 * @extends {React.FC<ICheckoutLoyaltyTextProps>}
 */
const CheckoutLoyaltyText: React.FC<ICheckoutLoyaltyTextProps> = ({ className, text }) => {
    if (!text) {
        return null;
    }

    return <span className={className}>{text}</span>;
};

export default CheckoutLoyaltyText;
